import { useTranslation } from "react-i18next"

import { AdaptiveLoader } from "@/components/AdaptiveLoader"
import { CenteringContainer } from "@/components/CenteringContainer"
import { OverlayDiv } from "@/components/OverlayDiv"

export const PendingSpinner = () => {
  const { t } = useTranslation()
  return (
    <OverlayDiv>
      <CenteringContainer>
        <div className="flex items-center gap-sm rounded-full bg-brand-primary px-xl py-sm">
          <AdaptiveLoader
            size={14}
            speed={0.8}
            separation={1.5}
            color="Colors/Foreground/fg-primary (900)"
            type="secondary"
          />
          <p className="text-md-bold text-white select-none">
            {t("liveRates.executionResponse.executing")}
          </p>
        </div>
      </CenteringContainer>
    </OverlayDiv>
  )
}
